import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CategoryManagement = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [updating, setUpdating] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const response = await axios.get('/api/zoho/admin/categories');
            setCategories(response.data);
            setError(null);
        } catch (err) {
            console.error('Error fetching categories:', err);
            setError('Failed to load categories');
        } finally {
            setLoading(false);
        }
    };

    const handleToggleVisibility = async (category) => {
        try {
            setUpdating(category.category_name);
            const newVisibility = !category.is_visible;
            
            await axios.post('/api/zoho/admin/categories', {
                categoryId: category.category_name, // On utilise le nom comme ID car Zoho n'a pas d'ID stable pour les catégories string
                categoryName: category.category_name,
                isVisible: newVisibility
            });

            // Mettre à jour l'état local
            setCategories(categories.map(c => 
                c.category_name === category.category_name 
                    ? { ...c, is_visible: newVisibility } 
                    : c
            ));
        } catch (err) {
            console.error('Error updating category:', err);
            alert('Failed to update category visibility');
        } finally {
            setUpdating(null);
        }
    };

    if (loading) return <div style={{ color: 'white', padding: '20px' }}>Loading categories...</div>;
    if (error) return <div style={{ color: '#ff6b6b', padding: '20px' }}>{error}</div>;

    return (
        <div className="category-management-section" style={{ 
            marginTop: '20px',
            background: 'white',
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
            <div className="admin-card-header" style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ color: '#333', fontSize: '28px', fontWeight: '600', marginBottom: '8px' }}>📂 Category Visibility</h2>
                <p style={{ color: '#666', fontSize: '16px', margin: 0 }}>Toggle which categories are visible in the public catalog</p>
            </div>
            
            <div className="admin-card-content">
                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', 
                    gap: '15px',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    padding: '10px'
                }}>
                    {categories.map((category) => (
                        <div 
                            key={category.category_name} 
                            style={{
                                background: category.is_visible ? '#f8f9fa' : '#ffe3e3',
                                padding: '15px',
                                borderRadius: '8px',
                                border: `1px solid ${category.is_visible ? '#dee2e6' : '#ffc9c9'}`,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                opacity: updating === category.category_name ? 0.7 : 1
                            }}
                        >
                            <span style={{ 
                                fontWeight: '500',
                                color: category.is_visible ? '#212529' : '#c92a2a'
                            }}>
                                {category.category_name}
                            </span>
                            
                            <label className="switch" style={{ position: 'relative', display: 'inline-block', width: '50px', height: '24px' }}>
                                <input 
                                    type="checkbox" 
                                    checked={category.is_visible}
                                    onChange={() => handleToggleVisibility(category)}
                                    disabled={updating === category.category_name}
                                    style={{ opacity: 0, width: 0, height: 0 }}
                                />
                                <span style={{
                                    position: 'absolute',
                                    cursor: 'pointer',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    backgroundColor: category.is_visible ? '#28a745' : '#ccc',
                                    transition: '.4s',
                                    borderRadius: '34px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        content: '""',
                                        height: '16px',
                                        width: '16px',
                                        left: category.is_visible ? '30px' : '4px',
                                        bottom: '4px',
                                        backgroundColor: 'white',
                                        transition: '.4s',
                                        borderRadius: '50%'
                                    }}></span>
                                </span>
                            </label>
                        </div>
                    ))}
                </div>
                {categories.length === 0 && (
                    <p style={{ textAlign: 'center', color: '#6c757d' }}>No categories found.</p>
                )}
            </div>
        </div>
    );
};

export default CategoryManagement;
